<template>
    <div>
    <el-table
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="data"
      :height="parentPanelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.instrumentName)'
    >
      <el-table-column :label="$t('Top 5 Exposure')" sortable prop='instrumentName'  align="left" />
      <el-table-column :label="$t('Volume USD')" sortable prop='volume' :sort-method='(a,b) => sortFloat(a,b,"volume")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.volume >= 0  ? "positive" : "negative"'>{{ scope.row.volume | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Volume Lot')" sortable prop='numberOfLot' :sort-method='(a,b) => sortFloat(a,b,"numberOfLot")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.numberOfLot >= 0  ? "positive" : "negative"'>{{ scope.row.numberOfLot | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Long')" sortable prop='volumeLong' :sort-method='(a,b) => sortFloat(a,b,"volumeLong")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.volumeLong >= 0  ? "positive" : "negative"'>{{ scope.row.volumeLong | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Short')" sortable prop='volumeShort' :sort-method='(a,b) => sortFloat(a,b,"volumeShort")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.volumeShort >= 0  ? "positive" : "negative"'>{{ scope.row.volumeShort | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('EOD')" sortable :sort-method='(a,b) => sortFloat(a,b,"rollOver")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.rollOver | formatRate(5) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Current')" sortable :sort-method='(a,b) => sortFloat(a,b,"best")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.best | formatRate(5) }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'TopExposurePnLReport',
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    }
  },
  computed: {
    //...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping }),
    isSymbolGrpKey: function () {
      //return this.groupKeys[this.panel.options.groupKey] === "symbol"
      return true
    }
  },
  methods: {
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'Symbol' : 'Currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
    }
  }
}
</script>

<style scoped>
</style>